<template>
  <div>
    <div class="mb-2" v-for="error in api_errors" :key="error.message" v-if="api_errors.length > 0">
        <vs-alert color="danger" icon="new_releases">
          <small>{{error}}</small>
        </vs-alert>
    </div>
    <vue-simple-suggest
      pattern="\w+"
      v-model="location_model"
      :list="getList"
      :max-suggestions="10"
      :min-length="1"
      :debounce="500"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27, 35]
      }"
      :mode="mode"
      :nullable-select="true"
      ref="suggestComponent"
      placeholder="Search Location"
      value-attribute="postal_code"
      display-attribute="postal_code"
      @select="onSuggestSelect">

    <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <!--<div class="misc-item">
        <span>Search: '{{ query }}'.</span>
        </div>

        <template v-if="suggestions.length > 0">
        <div class="misc-item">
            <span>{{ suggestions.length }} suggestions</span>
        </div>
        <hr>
        </template>-->

        <div class="misc-item" v-if="!loading && suggestions.length == 0">
        <span>No results</span>
        </div>
    </template>

    <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.code">
        <div class="vx-row">
        <div class="vx-col sm:w-5/6">
            <p v-html="boldenSuggestion(scope)"></p>
        </div>
        </div>
    </div>

    <div class="misc-item" slot="misc-item-below" slot-scope="{ suggestions }" v-if="loading">
        <span>Loading...</span>
    </div>
    </vue-simple-suggest>

    <div class="vx-row mt-2">
      <div class="vx-col w-full lg:w-1/3 mb-2">
        <small class="mt-2 w-full">Province</small>
        <vs-input
          :readonly="true"
          v-model="province_model"
          :placeholder="`Province`"
          class="w-full"/>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-2">
        <small class="mt-2 w-full">City</small>
        <vs-input
          :readonly="true"
          v-model="city_model"
          :placeholder="`State`"
          class="w-full"/>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-2">
        <small class="mt-2 w-full">District</small>
        <vs-input
          :readonly="true"
          v-model="district_model"
          :placeholder="`district`"
          class="w-full"/>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-2">
        <small class="mt-2 w-full">Subdistrict</small>
        <vs-input
          :readonly="true"
          v-model="subdistrict_model"
          :placeholder="`subdistrict`"
          class="w-full"/>
      </div>

      <div class="vx-col w-full lg:w-1/3 mb-2">
        <small class="mt-2 w-full">Postal Code</small>
        <vs-input
          :readonly="true"
          v-model="postal_code_model"
          :placeholder="`Postal Code`"
          class="w-full"/>
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
  name: 'sicepat-location-auto-complete',
  props:['location', 'province', 'city', 'district', 'subdistrict', 'postal_code'],
  data () {
    return {
      location_model: this.location,
      province_model: this.province,
      city_model: this.city,
      district_model: this.district,
      subdistrict_model: this.subdistrict,
      postal_code_model: this.postal_code,
      mode: 'input',
      loading: false,
      selected_suggest: {
        postal_code: null,
        district: null,
        city: null,
        province: null
      },
      api_errors: []
    }
  },
  components: {
    VueSimpleSuggest
  },
  methods: {
    getList (inputValue) {
      return new Promise((resolve, reject) => {
        this.loading = true
        const url = `${this.$endpoints.customer_sicepat_location  }?keyword=${  inputValue}`

        fetch(url).then(response => {
          if (!response.ok) {
            reject()
          }
          response.json().then(json => {
            const result = []
            json.data.forEach((part) => {
              result.push(part)
            })
            this.loading = false
            resolve(result)
          }).catch(e => {
            this.loading = false
            reject(e)
          })
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      })
    },
    onSuggestSelect (suggest) {
      this.$emit('onSelectSuggestion', suggest)
      this.selected_suggest = suggest
      this.api_errors = []
    },
    boldenSuggestion (scope) {
      if (!scope) return scope
      const { suggestion, query } = scope
      //let result = this.$refs.suggestComponent.displayProperty(suggestion);
      const result = `${suggestion.district  } - ${  suggestion.subdistrict  } - ${  suggestion.postal_code}`
      if (!query) return result
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || ['']
      if (result.length) {
        return result.replace(new RegExp(`(.*?)(${  texts.join('|')  })(.*?)`, 'gi'), '$1<b>$2</b>$3')
      }
    }
  }
}
</script>
